import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    position: "absolute",
    bottom: "10px",
    left: "0",
    right: "0",
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 2),
  },
  okButton: {
    backgroundColor: "#286ACF",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
  subtitle: {
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: 500,
  },
}));
export default function SuccessScreen({ setOpen, roleInfo, count, handleRefresh }) {
  const classes = useStyles();
  const handleOk = () => {
    handleRefresh();
    setOpen(false);
  };
  return (
    <Box style={{ marginTop: "8px" }}>
      <Typography
        style={{ display: "flex", fontSize: "16px", fontWeight: 600 }}
        gutterBottom
      >
        New role created successfully
        <CheckCircleIcon style={{ color: "green" }} />
      </Typography>
      <Typography className={classes.subtitle}>Department - Role</Typography>
      <Typography>
        {roleInfo.department} - {roleInfo.roleName}
      </Typography>
      <Typography className={classes.subtitle}>Role Description</Typography>
      <Typography>{roleInfo.roleDescription}</Typography>
      <Typography className={classes.subtitle}>Enabled</Typography>
      <Typography>
        {count.enabled} {count.enabled === 1 ? "permission" : "permissions"}
      </Typography>
      <Typography className={classes.subtitle}>Disabled</Typography>
      <Typography>
        {count.disabled} {count.disabled === 1 ? "permission" : "permissions"}
      </Typography>
      <Box className={classes.buttonContainer}>
        <Button onClick={handleOk} size="small" className={classes.okButton}>
          Ok
        </Button>
      </Box>
    </Box>
  );
}
